<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Contrato</p>
        </div>

        <div class="muven-card muven-card-md muven-card-centered">
            <div class="muven-card-title">
                <p>Termos de uso e contrato</p>
                <p class="muven-card-subtitle">{{subscriber.name}}</p>
            </div>

            <div>
                <p></p>
                <p>
                    <a :href="subscriber.agreementLink" target="_blank">
                        Clique aqui para baixar o contrato.
                        <fa icon="external-link-alt" class="ml-2 muven-external-link"/>
                    </a>
                </p>
                <p>Para confirmar que entendeu e está de acordo com o contrato apresentado, clique em "Li e aceito".</p>
            </div>

            <div class="muven-card-actions">
                <button type="button"
                    class="btn btn-primary"
                    @click="accept()"
                    :disabled="loading">
                        Li e aceito
                        <Loading v-if="loading" />
                </button>

                <button type="button"
                    class="btn btn-outline-secondary"
                    @click="doItLater()">
                        Ler mais tarde
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import subscriberService from '@/subscriber/services/SubscriberService'
import { logout } from '@/auth/services/SessionService'
import { mapState } from 'vuex'
import storeConstants from '../../utils/constants/StoreConstants'

export default {
    name: 'SubscriberAgreementView',
    data() {
        return {
            loading: false,
        }
    },
    mounted() {
        if (!this.subscriber.hasAgreementLink()) {
            this.$router.push('/')
            return
        }
    },
    methods: {
        async accept() {
            this.loading = true

            try {
                await subscriberService.acceptAgreement()
                await this.$store.dispatch(storeConstants.actions.GET_SUBSCRIBER_LIST)
                this.$router.push('/')
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })   
            }

            this.loading = false
        },
        doItLater() {
            this.$router.push('/')
        },
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
    },
}

</script>